<template>
  <Content :title="'Emitir Comprobante'">
    <Card :noHeader="true">
      <Comprobante2></Comprobante2>
    </Card>
  </Content>
</template>

<script>
import Comprobante2 from "../components/Comprobante2.vue";
import Card from "../../shared/components/Card.vue";
import Content from "../../shared/components/Content.vue";
export default {
  components: { Content, Card, Comprobante2 },
};
</script>

<style></style>
